<template>
    <form class="form-horizontal pl-2">
        <div class="form-group row">
            <label for="date" class="col-sm-3 col-form-label">Date:</label>
            <div class="col-sm-9">
                <input
                    id="date"
                    :value="start.toFormat('cccc, LLL d, yyyy \'at\' h:mm a')"
                    type="text"
                    readonly="readonly"
                    class="form-control-plaintext"
                />
            </div>
        </div>
        <div v-if="client" class="form-group row">
            <label for="client" class="col-sm-3 col-form-label">Client:</label>
            <div class="col-sm-9">
                <input
                    id="client"
                    :value="client.label"
                    type="text"
                    readonly="readonly"
                    class="form-control-plaintext"
                />
            </div>
        </div>
        <div v-if="client" class="form-group row">
            <label for="staticEmail" class="col-sm-3 col-form-label"
                >Patient:</label
            >
            <div class="col-sm-9">
                <input
                    v-if="patient"
                    :value="patient.name"
                    type="text"
                    readonly="readonly"
                    class="form-control-plaintext"
                />
            </div>
        </div>
        <div
            v-if="appointmentTypeAllowPrevisit && !isReschedule"
            class="form-group row"
        >
            <label for="confirmation_option" class="col-sm-3 col-form-label"
                >Pre-visit Info:</label
            >
            <div class="col-sm-9">
                <select
                    id="confirmation_option"
                    v-model="data.send_pre_visit"
                    class="form-control"
                >
                    <option :value="false"
                        >Do not send documents upon appointment creation</option
                    >
                    <option :value="true"
                        >Send documents upon appointment creation</option
                    >
                </select>
            </div>
        </div>
        <div v-if="client" class="form-group row">
            <label for="confirmation_option" class="col-sm-3 col-form-label"
                >Confirmation:</label
            >
            <div class="col-sm-9">
                <select
                    id="confirmation_option"
                    v-model="data.confirmation_option"
                    class="form-control"
                    :disabled="isClientNoOwner"
                >
                    <option value="NO">No confirmation</option>
                    <option v-if="client.email" value="BY_EMAIL">Email</option>
                    <option
                        v-if="
                            client.mobile &&
                            (_isExtensionEnabled('SMS') ||
                                _isExtensionEnabled('2_WAY_MESSAGING'))
                        "
                        value="BY_SMS"
                        >SMS (Text)</option
                    >
                </select>
            </div>
        </div>
        <div
            v-if="
                client &&
                _.includes(['BY_EMAIL', 'BY_SMS'], data.confirmation_option)
            "
            class="form-group row"
        >
            <label for="confirmation_message" class="col-sm-3 col-form-label"
                >Message:</label
            >
            <div class="col-sm-9">
                <ContentEditable
                    v-if="data.confirmation_option === 'BY_EMAIL'"
                    id="confirmation_message"
                    :key="confirmationMessageKey"
                    v-model="data.confirmation_message"
                    :noHTML="false"
                    tag="div"
                    class="form-control"
                >
                </ContentEditable>
                <textarea
                    id="confirmation_message"
                    v-else-if="data.confirmation_option === 'BY_SMS'"
                    :key="confirmationMessageKey"
                    v-model="data.confirmation_message"
                    class="form-control h-auto"
                    rows="6"
                    :maxlength="maxCharacters"
                ></textarea>
                <TextLimitIndicator
                    v-if="data.confirmation_option === 'BY_SMS'"
                    class="mb-0"
                    :max-length="maxCharacters"
                    :text="data.confirmation_message"
                />
            </div>
        </div>
        <div v-if="client && showReminder" class="form-group row">
            <label for="reminder_option" class="col-sm-3 col-form-label"
                >Reminder:</label
            >
            <div class="col-sm-9">
                <select
                    id="reminder_option"
                    v-model="data.reminder_option"
                    class="form-control"
                    :disabled="isClientNoOwner"
                >
                    <option
                        :value="opt.id"
                        v-for="opt in reminder_options_filter"
                        :key="opt.id"
                        >{{ opt.label }}
                    </option>
                </select>
            </div>
        </div>
        <div
            v-if="
                client &&
                _.includes(
                    [
                        APPOINTMENTS.REMINDER_OPTIONS.EMAIL,
                        APPOINTMENTS.REMINDER_OPTIONS.SMS
                    ],
                    data.reminder_option
                ) &&
                showReminder
            "
            class="form-group row"
        >
            <label for="reminder_send" class="col-sm-3 col-form-label"
                >Send:</label
            >
            <div class="col-sm-9 pr-0">
                <div class="row container-fluid pr-0">
                    <input
                        id="reminder_send"
                        v-model="data.reminder_send"
                        v-validate="'required|numeric'"
                        :placeholder="
                            _periodText(data.time_period_id) + ' (required)'
                        "
                        :class="{
                            'border-danger': errors.has('reminder_send')
                        }"
                        name="reminder_send"
                        type="number"
                        min="0"
                        step="1"
                        class="form-control col mr-2"
                    />
                    <select
                        id="reminder_time_period"
                        v-model="data.time_period_id"
                        name="reminder_time_period"
                        class="form-control col mr-2"
                        aria-invalid="false"
                    >
                        <option value="4" selected="selected">Day(s)</option>
                        <option value="5">Week(s)</option>
                        <option value="6">Month(s)</option>
                        <option value="7">Year(s)</option>
                    </select>
                    <select
                        v-model="data.reminder_send_option_id"
                        class="form-control col"
                        aria-invalid="false"
                    >
                        <option value="1">Before Due</option>
                        <option value="2">After Due</option>
                    </select>
                </div>
            </div>
        </div>
        <div
            v-if="
                client &&
                _.includes(
                    [
                        APPOINTMENTS.REMINDER_OPTIONS.EMAIL,
                        APPOINTMENTS.REMINDER_OPTIONS.SMS
                    ],
                    data.reminder_option
                ) &&
                showReminder
            "
            class="form-group row"
        >
            <label for="reminder_message" class="col-sm-3 col-form-label"
                >Message:</label
            >
            <div class="col-sm-9">
                <ContentEditable
                    v-if="
                        data.reminder_option ===
                        APPOINTMENTS.REMINDER_OPTIONS.EMAIL
                    "
                    id="reminder_message"
                    v-model="data.reminder_message"
                    :noHTML="false"
                    tag="div"
                    class="form-control"
                >
                </ContentEditable>
                <textarea
                    id="reminder_message"
                    v-else-if="
                        data.reminder_option ===
                        APPOINTMENTS.REMINDER_OPTIONS.SMS
                    "
                    v-model="data.reminder_message"
                    class="form-control h-auto"
                    rows="6"
                    :maxlength="maxCharacters"
                ></textarea>
                <TextLimitIndicator
                    v-if="
                        data.reminder_option ===
                        APPOINTMENTS.REMINDER_OPTIONS.SMS
                    "
                    class="mb-0"
                    :max-length="maxCharacters"
                    :text="data.reminder_message"
                />
            </div>
        </div>
    </form>
</template>
<style></style>

<script>
import ContentEditable from "vue-contenteditable/src/contenteditable.vue";
import ScheduleHelper from "@/module/schedule/helper";
import { sortBy, map, find, get, clone } from "lodash";
import APPOINTMENTS from "@/constants/appointments";
import TextLimitIndicator from "@/components/commons/text-limit-indicator";
import Account from "@/services/account";

const CUSTOM_SMS = 1;
export default {
    components: { ContentEditable, TextLimitIndicator },
    mixins: [ScheduleHelper],
    // eslint-disable-next-line vue/require-prop-types
    props: {
        data: {
            type: Object,
            default() {
                return {};
            }
        },
        showReminder: {
            type: Boolean,
            default: true
        },
        isReschedule: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            resources: {},
            reminderSetting: {},
            reminder_options: [
                { id: 4, index: 0, label: "No reminder" },
                { id: 1, index: 1, label: "Email" },
                { id: 3, index: 2, label: "Mail" },
                { id: 2, index: 3, label: "Phone" },
                { id: 5, index: 4, label: "SMS (Text)" }
            ],
            email_confirmation_message: "",
            sms_confirmation_message: "",
            confirmationMessageKey: 0,
            email_reminder_message: "",
            sms_reminder_message: "",
            date_format: "DD/MM/YYYY",
            reminder_options_filter: [], // from computed to data. refer method "filterReminder",
            maxCharacters: 1500,
            APPOINTMENTS
        };
    },
    computed: {
        start() {
            return this._toDateTime(this.data.start);
        },
        client() {
            return this.data.client;
        },
        patient() {
            return this.data.patient;
        },
        period_txt() {
            switch (parseInt(this.data.time_period_id)) {
                case 4:
                    return "Days";
                case 5:
                    return "Weeks";
                case 6:
                    return "Months";
                case 7:
                    return "Years";
                default:
                    return "Days";
            }
        },
        isClientNoOwner() {
            return this?.data?.client?.index === 1;
        },
        appointmentTypeAllowPrevisit() {
            return (
                this._isExtensionEnabled("PREVISIT") &&
                this.data.appointmentType &&
                this.data.appointmentType.previsit === 1
            );
        }
    },
    watch: {
        "data.confirmation_option": {
            handler(value) {
                if (value) {
                    if (value === "BY_EMAIL") {
                        this.data.confirmation_message = this.email_confirmation_message;
                    }
                    if (value === "BY_SMS") {
                        this.data.confirmation_message = this.sms_confirmation_message;
                    }
                } else {
                    this.data.confirmation_message = this.email_confirmation_message;
                }
            }
        },
        "data.reminder_option": {
            handler(value) {
                if (value) {
                    if (value === APPOINTMENTS.REMINDER_OPTIONS.EMAIL) {
                        this.data.reminder_message = this.email_reminder_message;
                    } else if (value === APPOINTMENTS.REMINDER_OPTIONS.SMS) {
                        this.data.reminder_message = this.sms_reminder_message;
                    } else {
                        this.data.reminder_message = "";
                    }
                } else {
                    this.data.reminder_message = this.email_reminder_message;
                }
            }
        }
    },
    mounted() {
        let self = this;
        let isNoReminder = false;
        this.date_format = this.getDateFormat();

        if (self.client) {
            this.$emit("loading");

            if (this.isClientNoOwner) {
                this.$emit("loaded");
                this.filterReminder(this.client.reminder_options);
                this.data.confirmation_option = "NO"; // i know we shouldnt do this (mutate props) but... just follow the legacy code - luqman
                this.data.reminder_option =
                    APPOINTMENTS.REMINDER_OPTIONS.NO_REMINDER;
                return;
            }

            this._getDefaultReminderSetting()
                .then(async reminderSetting => {
                    self.reminderSetting = reminderSetting;
                    let promise = null;
                    if (
                        this.client.mobile &&
                        self.data.appointmentType.custom_sms_confirmation ==
                            CUSTOM_SMS
                    ) {
                        this.data.confirmation_option = "BY_SMS";
                    } else {
                        if (
                            this.client.email &&
                            this.$root.setting.appointment_confirmation ===
                                "BY_EMAIL"
                        ) {
                            if (
                                // if option No Confirmation is selected value="0000000000000000"
                                (self.data.appointmentType
                                    .confirmation_template_id ==
                                    "0000000000000000" &&
                                    !self.data.appointmentType
                                        .confirmation_template) ||
                                this.checkNullCharsUnicode(
                                    self.data.appointmentType
                                        .confirmation_template_id
                                )
                            ) {
                                self.data.confirmation_option = "NO";
                            } else {
                                this.data.confirmation_option = this.$root.setting.appointment_confirmation;
                            }
                        } else if (
                            this.client.mobile &&
                            this.$root.setting.appointment_confirmation ===
                                "BY_SMS"
                        ) {
                            if (
                                // if option No Confirmation is selected value="0000000000000000"
                                (self.data.appointmentType
                                    .confirmation_template_id ==
                                    "0000000000000000" &&
                                    !self.data.appointmentType
                                        .confirmation_template) ||
                                this.checkNullCharsUnicode(
                                    self.data.appointmentType
                                        .confirmation_template_id
                                )
                            ) {
                                self.data.confirmation_option = "NO";
                            } else {
                                this.data.confirmation_option = this.$root.setting.appointment_confirmation;
                            }
                        } else if (self.data.confirmation_option == null) {
                            this.data.confirmation_option = "NO";
                        }
                    }

                    if (!self.client.reminder_options) {
                        //call api to get client reminder options if self.client.reminder_options is empty
                        promise = this.$http
                            .get(
                                process.env.ACTOR_SERVICE +
                                    "client/" +
                                    self.client.id +
                                    "/reminder-option-ids"
                            )
                            .then(function (response) {
                                if (
                                    response.data.response.message.code === 200
                                ) {
                                    self.client.reminder_options = response.data.response.resources.map(
                                        option => parseInt(option)
                                    );

                                    self.filterReminder(
                                        self.client.reminder_options
                                    );

                                    return self.client.reminder_options;
                                }
                            });
                    } else {
                        self.filterReminder(self.client.reminder_options);
                        promise = Promise.resolve(true);
                    }

                    return promise.then(async () => {
                        // Extension check VET-11296: To check the SMS or 2_WAY_Messaging extension enabled or disabled
                        const isSmsExtensionEnabled = await Account.checkExtensionsEnabled(
                            "SMS"
                        );
                        const is2WaySmsExtensionEnabled = await Account.checkExtensionsEnabled(
                            "2_WAY_MESSAGING"
                        );
                        const hasSmsExtension =
                            isSmsExtensionEnabled || is2WaySmsExtensionEnabled;
                        // Edit appointment
                        if (self.data.id && self.data.reminders.length > 0) {
                            let isSMSAvailable = find(
                                self.reminder_options_filter,
                                {
                                    id: APPOINTMENTS.REMINDER_OPTIONS.SMS
                                }
                            );

                            if (
                                find(self.reminder_options_filter, {
                                    id: get(
                                        self,
                                        "reminderSetting.reminder_type_id"
                                    )
                                })
                            ) {
                                if (
                                    Boolean(isSMSAvailable) &&
                                    self.data.appointmentType
                                        ?.custom_sms_reminder == CUSTOM_SMS &&
                                    hasSmsExtension
                                ) {
                                    this.data.reminder_option =
                                        APPOINTMENTS.REMINDER_OPTIONS.SMS;
                                } else {
                                    this.data.reminder_option =
                                        self.reminderSetting.reminder_type_id;
                                }
                            } else {
                                if (self.client.reminder_options.length > 0) {
                                    if (
                                        Boolean(isSMSAvailable) &&
                                        self.data.appointmentType
                                            ?.custom_sms_reminder ==
                                            CUSTOM_SMS &&
                                        hasSmsExtension
                                    ) {
                                        self.data.reminder_option =
                                            APPOINTMENTS.REMINDER_OPTIONS.SMS;
                                    } else {
                                        self.data.reminder_option = Number(
                                            self.client.reminder_options[0]
                                        );
                                    }
                                } else {
                                    self.data.reminder_option =
                                        APPOINTMENTS.REMINDER_OPTIONS.NO_REMINDER;
                                }
                            }

                            self.data.reminder_send = get(
                                self,
                                "data.reminders[0].reminder_send"
                            );
                            self.data.reminder_send_option_id = get(
                                self,
                                "data.reminders[0].reminder_send_option_id"
                            );
                            self.data.time_period_id = get(
                                self,
                                "data.reminders[0].time_period_id"
                            );
                        } else {
                            // New appointment
                            let options = self.client.reminder_options;

                            if (
                                options.length == 1 &&
                                Number(options[0]) == self.REMINDER_TYPE.SMS &&
                                hasSmsExtension
                            ) {
                                if (
                                    self.$root.setting
                                        .appointment_confirmation !== "NO"
                                ) {
                                    if (self.client.mobile) {
                                        self.data.confirmation_option =
                                            "BY_SMS";
                                    }
                                }

                                if (
                                    self.reminderSetting.reminder_type_id ===
                                    self.REMINDER_TYPE.NO_REMINDER
                                ) {
                                    self.data.reminder_option =
                                        self.REMINDER_TYPE.NO_REMINDER;
                                } else {
                                    self.data.reminder_option =
                                        self.REMINDER_TYPE.SMS;
                                }
                            } else if (
                                find(self.reminder_options_filter, {
                                    id: get(
                                        self,
                                        "reminderSetting.reminder_type_id"
                                    )
                                })
                            ) {
                                let isSMSAvailable = find(
                                    self.reminder_options_filter,
                                    {
                                        id: APPOINTMENTS.REMINDER_OPTIONS.SMS
                                    }
                                );

                                if (
                                    Boolean(isSMSAvailable) &&
                                    self.data.appointmentType
                                        ?.custom_sms_reminder == CUSTOM_SMS &&
                                    hasSmsExtension
                                ) {
                                    this.data.reminder_option =
                                        APPOINTMENTS.REMINDER_OPTIONS.SMS;
                                } else {
                                    this.data.reminder_option =
                                        self.reminderSetting.reminder_type_id;
                                }
                            } else {
                                self.data.reminder_option = options.length
                                    ? Number(options[0])
                                    : APPOINTMENTS.REMINDER_OPTIONS.NO_REMINDER;
                            }
                        }

                        if (
                            self.data.appointmentType.reminder_template_id ==
                                "0000000000000000" &&
                            !self.data.appointmentType.reminder_template
                        ) {
                            isNoReminder = true;
                            self.data.reminder_option =
                                APPOINTMENTS.REMINDER_OPTIONS.NO_REMINDER;
                        }

                        if (
                            self.data.appointmentType.is_send_reminder == 1 &&
                            !isNoReminder
                        ) {
                            self.data.reminder_send =
                                self.data.appointmentType.reminder_send;
                            self.data.time_period_id =
                                self.data.appointmentType.reminder_time_period_id;
                            self.data.reminder_send_option_id =
                                self.data.appointmentType.reminder_send_option_id;
                        } else {
                            self.data.reminder_send =
                                self.reminderSetting.reminder_send;
                            self.data.time_period_id =
                                self.reminderSetting.time_period_id;
                            self.data.reminder_send_option_id =
                                self.reminderSetting.reminder_send_option_id;
                        }

                        return self.getEmailMessages();
                    });
                })
                .finally(() => this.$emit("loaded"));
        }
    },
    methods: {
        setDefaultSMSMessage() {
            let message = "";

            if (
                this.data.patient &&
                !this.data.appointmentType?.custom_sms_reminder
            ) {
                // Has patient and not a custom message
                message =
                    "Reminder from " +
                    this.$root.setting.business.name +
                    ". " +
                    this.data.patient.name +
                    "'s appt is on " +
                    this.data.start.toFormat(this._getLuxonFormat()) +
                    " at " +
                    this.data.start.toFormat("h:mm a") +
                    ". Confirm: {CONFIRM_LINK}";
            } else if (!this.data.appointmentType?.custom_sms_reminder) {
                message =
                    "Reminder from " +
                    this.$root.setting.business.name +
                    ". Your appt is on " +
                    this.data.start.toFormat(this._getLuxonFormat()) +
                    " at " +
                    this.data.start.toFormat("h:mm a") +
                    ". Confirm: {CONFIRM_LINK}";
            }
            return message;
        },
        /**
         * we're using this function instead of
         * computed value - for filtered options - because
         * method will force re-render everytime we call it.
         */
        filterReminder(clientReminders = []) {
            let reminder_options = this.reminder_options;

            let filtered = sortBy(
                map(clientReminders.concat(["4"]), n => {
                    return find(reminder_options, { id: parseInt(n) });
                }),
                "index"
            );

            this.reminder_options_filter = filtered;
        },
        getReminderSetting(id) {
            let self = this;
            return this.$http
                .get(
                    process.env.SCHEDULE_SERVICE +
                        "appointment/" +
                        id +
                        "/reminder"
                )
                .then(function (response) {
                    self.reminderSetting = response.data.response.resources;
                });
        },
        async getEmailMessages() {
            let params = [];
            params[0] = {
                client_id: this.data.client.id,
                recipient_id: this.data.client.id,
                recipient_type: 0,
                patient_id: this.data.patient ? [this.data.patient.id] : [],
                appointment_id: this.data.id,
                appointment_date: this.data.start.toFormat(
                    this._getLuxonFormat()
                ),
                appointment_day: this.start.toFormat("cccc"),
                appointment_time: this.start.toFormat("h:mm a"),
                appointment_reason: this.data.reason,
                appointment_complaint: this.data.reason,
                note: this.data.note,
                appointment_note: this.data.note,
                appointment_type_id: this.data.appointmentType.id,
                appointment_type: this.data.appointmentType.type,
                appointment_provider: this.data.staff
                    ? this.data.staff.providerName
                    : "",
                skip_appointment: true,
                email_type: this.EMAIL_TYPE.APPOINTMENT_CONFIRMATION
            };

            params[1] = clone(params[0]);
            params[1].email_type = this.EMAIL_TYPE.APPOINTMENT_REMINDER;

            let data = await $.post(
                process.env.APPS +
                    "index.php/common/appointment/getEmailTemplate",
                { params }
            );
            if (data && data.response) {
                // Confirmation message
                this.email_confirmation_message =
                    data.response[0].email_template.message;
                this.sms_confirmation_message =
                    data.response?.sms_confirmation_message?.message;

                // Reminder message
                this.email_reminder_message =
                    data.response[1].email_template.message;
                this.sms_reminder_message =
                    data.response?.sms_reminder_message?.message;
                // Set the reminder message based on the reminder option
                if (
                    this.data.reminder_option ===
                    APPOINTMENTS.REMINDER_OPTIONS.EMAIL
                ) {
                    this.data.reminder_message = this.email_reminder_message;
                } else if (
                    this.data.reminder_option ===
                    APPOINTMENTS.REMINDER_OPTIONS.SMS
                ) {
                    this.data.reminder_message = this.sms_reminder_message;
                }
                // Set the confirmation message based on the confirmation option
                if (this.data.confirmation_option === "BY_SMS") {
                    this.data.confirmation_message = this.sms_confirmation_message;

                    this.confirmationMessageKey++;
                } else if (this.data.confirmation_option === "BY_EMAIL") {
                    this.data.confirmation_message = this.email_confirmation_message;
                    this.confirmationMessageKey++;
                }
            } else {
                this._message("Error retriving email message", "danger");
            }
        }
    }
};
</script>
